var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "inscription-form", attrs: { id: "inscription-form" } },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "register-fee text-center p-3 mb-3" }, [
            _c("p", [
              _vm._v("Coût de l'inscription : "),
              _c("br"),
              _vm._v(" "),
              _c("strong", [_vm._v(_vm._s(_vm.registrationFee))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "alert alert-warning" }, [
            _c("p", [
              _vm._v(
                "Attention, si vous avez déjà effectué un premier règlement de " +
                  _vm._s(_vm.registrationFee) +
                  " pour\n                    l’inscription et que vous n’avez pas encore passé l’examen, il est inutile de vous réinscrire au\n                    risque de payer une seconde fois."
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "form",
            { staticClass: "inscription-form" },
            [
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "legend",
                    {
                      staticClass: "col-form-label required-input col-sm-2 pt-0"
                    },
                    [_vm._v("Civilité :")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-sm-10" },
                    _vm._l(_vm.genderEnum, function(gender) {
                      return _c(
                        "div",
                        { staticClass: "form-check form-check-inline mr-5" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inscription.gender,
                                expression: "inscription.gender"
                              }
                            ],
                            staticClass: "form-check-input",
                            attrs: {
                              type: "radio",
                              name: gender,
                              required: "",
                              id: gender
                            },
                            domProps: {
                              value: gender,
                              checked: _vm._q(_vm.inscription.gender, gender)
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.inscription,
                                  "gender",
                                  gender
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "form-check-label",
                              attrs: { for: gender }
                            },
                            [_vm._v(_vm._s(_vm._f("capitalize")(gender)))]
                          )
                        ]
                      )
                    }),
                    0
                  )
                ]),
                _vm._v(" "),
                !_vm.$v.inscription.gender.required &&
                _vm.$v.inscription.gender.$dirty
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(
                        "\n                        Merci de choisir une civilité\n                    "
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  { staticClass: "required-input", attrs: { for: "lastName" } },
                  [_vm._v("Nom de famille :")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.lazy",
                      value: _vm.$v.inscription.lastName.$model,
                      expression: "$v.inscription.lastName.$model",
                      modifiers: { lazy: true }
                    }
                  ],
                  staticClass: "form-control",
                  class: {
                    "invalid-input":
                      _vm.$v.inscription.lastName.$invalid &&
                      _vm.$v.inscription.lastName.$dirty
                  },
                  attrs: {
                    placeholder:
                      "Nom tel qu’indiqué sur votre pièce d'identité",
                    type: "text",
                    id: "lastName",
                    required: ""
                  },
                  domProps: { value: _vm.$v.inscription.lastName.$model },
                  on: {
                    change: function($event) {
                      return _vm.$set(
                        _vm.$v.inscription.lastName,
                        "$model",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                !_vm.$v.inscription.lastName.required &&
                _vm.$v.inscription.lastName.$dirty
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(
                        "Merci de saisir\n                        un nom\n                    "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$v.inscription.lastName.maxLength
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v("50 caractères maximum")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$v.inscription.lastName.noSpecialCharacters
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(
                        "Merci de supprimer\n                        les caractères spéciaux (caractères acceptés : lettres\n                        (-) (') (espace))\n                    "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.errorField === "lastName"
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(_vm._s(_vm.errorFieldMessage))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "required-input",
                    attrs: { for: "firstNames" }
                  },
                  [_vm._v("Prénom :")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.lazy",
                      value: _vm.$v.inscription.firstName.$model,
                      expression: "$v.inscription.firstName.$model",
                      modifiers: { lazy: true }
                    }
                  ],
                  staticClass: "form-control",
                  class: {
                    "invalid-input":
                      _vm.$v.inscription.firstName.$invalid &&
                      _vm.$v.inscription.firstName.$dirty
                  },
                  attrs: {
                    placeholder:
                      "Premier prénom tel qu'indiqué sur votre pièce d'identité",
                    type: "text",
                    id: "firstNames",
                    required: ""
                  },
                  domProps: { value: _vm.$v.inscription.firstName.$model },
                  on: {
                    change: function($event) {
                      return _vm.$set(
                        _vm.$v.inscription.firstName,
                        "$model",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                !_vm.$v.inscription.firstName.required &&
                _vm.$v.inscription.firstName.$dirty
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(
                        "Merci de\n                        saisir un prénom\n                    "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$v.inscription.firstName.maxLength
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v("50 caractères maximum")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$v.inscription.firstName.noSpecialCharacters
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(
                        "Merci de supprimer\n                        les caractères spéciaux (caractères acceptés : lettres\n                        (-) (') (espace))\n                    "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.errorField === "firstNames"
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(_vm._s(_vm.errorFieldMessage))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "firstNames2" } }, [
                  _vm._v("Second(s) prénom(s) :")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.lazy",
                      value: _vm.$v.inscription.firstName2.$model,
                      expression: "$v.inscription.firstName2.$model",
                      modifiers: { lazy: true }
                    }
                  ],
                  staticClass: "form-control",
                  class: {
                    "invalid-input":
                      _vm.$v.inscription.firstName2.$invalid &&
                      _vm.$v.inscription.firstName2.$dirty
                  },
                  attrs: {
                    placeholder: "Exemple : Jean-Pierre, Paul",
                    type: "text",
                    id: "firstNames2"
                  },
                  domProps: { value: _vm.$v.inscription.firstName2.$model },
                  on: {
                    change: function($event) {
                      return _vm.$set(
                        _vm.$v.inscription.firstName2,
                        "$model",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                !_vm.$v.inscription.firstName2.maxLength
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v("50 caractères maximum")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$v.inscription.firstName2.noSpecialCharacters
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(
                        "Merci de supprimer\n                        les caractères spéciaux (caractères acceptés\n                        : lettres (-) (') (espace))\n                    "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.errorField === "firstNames2"
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(_vm._s(_vm.errorFieldMessage))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "required-input",
                    attrs: { for: "dateOfBirth" }
                  },
                  [_vm._v("Date de naissance :")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.lazy",
                      value: _vm.$v.birthDateText.$model,
                      expression: "$v.birthDateText.$model",
                      modifiers: { lazy: true }
                    }
                  ],
                  staticClass: "form-control",
                  class: {
                    "invalid-input":
                      _vm.$v.birthDateText.$invalid &&
                      _vm.$v.birthDateText.$dirty
                  },
                  attrs: {
                    type: "text",
                    id: "dateOfBirth",
                    required: "",
                    placeholder: "jj/mm/aaaa"
                  },
                  domProps: { value: _vm.$v.birthDateText.$model },
                  on: {
                    change: [
                      function($event) {
                        return _vm.$set(
                          _vm.$v.birthDateText,
                          "$model",
                          $event.target.value
                        )
                      },
                      _vm.onChangeInputBirthDateText
                    ]
                  }
                }),
                _vm._v(" "),
                !_vm.$v.birthDateText.required && _vm.$v.birthDateText.$dirty
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(
                        "Merci de\n                        saisir une date de naissance\n                    "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$v.birthDateText.dateFormatIsValid
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(
                        "Merci de saisir la date au\n                        format jj/mm/aaaa (exemple : 01/10/1980)\n                    "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$v.birthDateText.haveMinAge
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(
                        "Vous devez avoir 16 ans ou plus pour\n                        vous inscrire à une session d'examen\n                    "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$v.birthDateText.birthDateGreaterThan
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(
                        "La date de naissance doit\n                        être supérieure à 01/01/1900\n                    "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.errorField === "dateOfBirth"
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(_vm._s(_vm.errorFieldMessage))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "required-input",
                    attrs: { for: "cityOfBirth" }
                  },
                  [_vm._v("Ville de naissance :")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.lazy",
                      value: _vm.$v.inscription.cityOfBirth.$model,
                      expression: "$v.inscription.cityOfBirth.$model",
                      modifiers: { lazy: true }
                    }
                  ],
                  staticClass: "form-control",
                  class: {
                    "invalid-input":
                      _vm.$v.inscription.cityOfBirth.$invalid &&
                      _vm.$v.inscription.cityOfBirth.$dirty
                  },
                  attrs: { type: "text", id: "cityOfBirth", required: "" },
                  domProps: { value: _vm.$v.inscription.cityOfBirth.$model },
                  on: {
                    change: function($event) {
                      return _vm.$set(
                        _vm.$v.inscription.cityOfBirth,
                        "$model",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                !_vm.$v.inscription.cityOfBirth.required &&
                _vm.$v.inscription.cityOfBirth.$dirty
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(
                        "Merci de\n                        saisir une ville de naissance\n                    "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$v.inscription.cityOfBirth.maxLength
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v("50 caractères maximum")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$v.inscription.cityOfBirth.noSpecialCharacters
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(
                        "Merci de\n                        supprimer les caractères spéciaux (caractères acceptés\n                        : lettres (-) (') (espace))\n                    "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.errorField === "cityOfBirth"
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(_vm._s(_vm.errorFieldMessage))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-lg-6" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      {
                        staticClass: "required-input",
                        attrs: { for: "countryOfBirth" }
                      },
                      [_vm._v("Pays de naissance :")]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.lazy",
                            value: _vm.$v.inscription.countryOfBirth.$model,
                            expression: "$v.inscription.countryOfBirth.$model",
                            modifiers: { lazy: true }
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "invalid-input":
                            _vm.$v.inscription.countryOfBirth.$invalid &&
                            _vm.$v.inscription.countryOfBirth.$dirty
                        },
                        attrs: { id: "countryOfBirth", required: "" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.$v.inscription.countryOfBirth,
                              "$model",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      _vm._l(_vm.countryEnum, function(country) {
                        return _c(
                          "option",
                          {
                            attrs: { label: country },
                            domProps: { value: country }
                          },
                          [
                            _vm._v(
                              _vm._s(country) +
                                "\n                                "
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    !_vm.$v.inscription.countryOfBirth.required &&
                    _vm.$v.inscription.countryOfBirth.$dirty
                      ? _c("div", { staticClass: "error-text" }, [
                          _vm._v(
                            "\n                                Merci de saisir un pays de\n                                naissance\n                            "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.errorField === "countryOfBirth"
                      ? _c("div", { staticClass: "error-text" }, [
                          _vm._v(
                            _vm._s(_vm.errorFieldMessage) +
                              "\n                            "
                          )
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-lg-6" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      {
                        staticClass: "required-input",
                        attrs: { for: "nationality" }
                      },
                      [_vm._v("Nationalité :")]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.lazy",
                            value: _vm.$v.inscription.nationality.$model,
                            expression: "$v.inscription.nationality.$model",
                            modifiers: { lazy: true }
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "invalid-input":
                            _vm.$v.inscription.nationality.$invalid &&
                            _vm.$v.inscription.nationality.$dirty
                        },
                        attrs: { id: "nationality", required: "" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.$v.inscription.nationality,
                              "$model",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      _vm._l(_vm.nationalityEnum, function(nationality) {
                        return _c(
                          "option",
                          {
                            attrs: { nationality: nationality },
                            domProps: { value: nationality }
                          },
                          [
                            _vm._v(
                              _vm._s(nationality) +
                                "\n                                "
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    !_vm.$v.inscription.nationality.required &&
                    _vm.$v.inscription.nationality.$dirty
                      ? _c("div", { staticClass: "error-text" }, [
                          _vm._v(
                            "\n                                Merci de saisir une nationalité\n                            "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.errorField === "nationality"
                      ? _c("div", { staticClass: "error-text" }, [
                          _vm._v(
                            _vm._s(_vm.errorFieldMessage) +
                              "\n                            "
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  { staticClass: "required-input", attrs: { for: "address1" } },
                  [_vm._v("Adresse 1 :")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.lazy",
                      value: _vm.$v.inscription.address1.$model,
                      expression: "$v.inscription.address1.$model",
                      modifiers: { lazy: true }
                    }
                  ],
                  staticClass: "form-control",
                  class: {
                    "invalid-input":
                      _vm.$v.inscription.address1.$invalid &&
                      _vm.$v.inscription.address1.$dirty
                  },
                  attrs: {
                    placeholder:
                      "Celle utilisée pour l'envoi postal de votre CRR",
                    type: "text",
                    id: "address1",
                    required: ""
                  },
                  domProps: { value: _vm.$v.inscription.address1.$model },
                  on: {
                    change: function($event) {
                      return _vm.$set(
                        _vm.$v.inscription.address1,
                        "$model",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                !_vm.$v.inscription.address1.required &&
                _vm.$v.inscription.address1.$dirty
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(
                        "Merci de saisir\n                        une adresse\n                    "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$v.inscription.address1.maxLength
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v("250 caractères maximum")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.errorField === "address1"
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(_vm._s(_vm.errorFieldMessage))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "address2" } }, [
                  _vm._v("Adresse 2 :")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.lazy",
                      value: _vm.$v.inscription.address2.$model,
                      expression: "$v.inscription.address2.$model",
                      modifiers: { lazy: true }
                    }
                  ],
                  staticClass: "form-control",
                  class: {
                    "invalid-input":
                      _vm.$v.inscription.address2.$invalid &&
                      _vm.$v.inscription.address2.$dirty
                  },
                  attrs: { type: "text", id: "address2" },
                  domProps: { value: _vm.$v.inscription.address2.$model },
                  on: {
                    change: function($event) {
                      return _vm.$set(
                        _vm.$v.inscription.address2,
                        "$model",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                !_vm.$v.inscription.address2.maxLength
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v("250 caractères maximum")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.errorField === "address2"
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(_vm._s(_vm.errorFieldMessage))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  { staticClass: "required-input", attrs: { for: "country" } },
                  [_vm._v("Pays :")]
                ),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.lazy",
                        value: _vm.$v.inscription.country.$model,
                        expression: "$v.inscription.country.$model",
                        modifiers: { lazy: true }
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      "invalid-input":
                        _vm.$v.inscription.country.$invalid &&
                        _vm.$v.inscription.country.$dirty
                    },
                    attrs: { id: "country", required: "" },
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.$v.inscription.country,
                            "$model",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                        _vm.onChangeCountryInput
                      ]
                    }
                  },
                  _vm._l(_vm.countryEnum, function(country) {
                    return _c(
                      "option",
                      {
                        attrs: { label: country },
                        domProps: { value: country }
                      },
                      [_vm._v(_vm._s(country) + "\n                        ")]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                !_vm.$v.inscription.country.required &&
                _vm.$v.inscription.country.$dirty
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(
                        "Merci de saisir un\n                        pays\n                    "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.errorField === "country"
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(_vm._s(_vm.errorFieldMessage))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-lg-6" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "required-input",
                          attrs: { for: "postalCode" }
                        },
                        [_vm._v("Code postal :")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.inscription.postalCode,
                            expression: "inscription.postalCode"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "invalid-input":
                            _vm.$v.inscription.postalCode.$invalid &&
                            _vm.$v.inscription.postalCode.$dirty
                        },
                        attrs: {
                          placeholder: "Exemple : 88100",
                          type: "text",
                          id: "postalCode",
                          required: ""
                        },
                        domProps: { value: _vm.inscription.postalCode },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.inscription,
                                "postalCode",
                                $event.target.value
                              )
                            },
                            _vm.onChangeInputPostalCode
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _vm.autocompleteOnPostalCode && _vm.enableAutocompletion
                        ? _c("autocompletion-location", {
                            attrs: { searchedLocation: _vm.searchedLocation },
                            on: { clickOnResult: _vm.setSelectedLocation }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.inscription.postalCode.required &&
                      _vm.$v.inscription.postalCode.$dirty
                        ? _c("div", { staticClass: "error-text" }, [
                            _vm._v(
                              "\n                                Merci de saisir un code postal\n                            "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.inscription.postalCode.frenchCpMustHave5Digits
                        ? _c("div", { staticClass: "error-text" }, [
                            _vm._v(
                              "Merci\n                                de saisir un code postal valide (5 chiffres)\n                            "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errorField === "postalCode"
                        ? _c("div", { staticClass: "error-text" }, [
                            _vm._v(_vm._s(_vm.errorFieldMessage))
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-lg-6" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "required-input",
                          attrs: { for: "city" }
                        },
                        [_vm._v("Ville :")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.inscription.city,
                            expression: "inscription.city"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "invalid-input":
                            _vm.$v.inscription.city.$invalid &&
                            _vm.$v.inscription.city.$dirty
                        },
                        attrs: { type: "text", id: "city", required: "" },
                        domProps: { value: _vm.inscription.city },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.inscription,
                                "city",
                                $event.target.value
                              )
                            },
                            _vm.onChangeInputCity
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _vm.autocompleteOnCity && _vm.enableAutocompletion
                        ? _c("autocompletion-location", {
                            attrs: { searchedLocation: _vm.searchedLocation },
                            on: { clickOnResult: _vm.setSelectedLocation }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.inscription.city.required &&
                      _vm.$v.inscription.city.$dirty
                        ? _c("div", { staticClass: "error-text" }, [
                            _vm._v(
                              "Merci de saisir\n                                une ville\n                            "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.inscription.city.maxLength
                        ? _c("div", { staticClass: "error-text" }, [
                            _vm._v(
                              "50 caractères maximum\n                            "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errorField === "city"
                        ? _c("div", { staticClass: "error-text" }, [
                            _vm._v(_vm._s(_vm.errorFieldMessage))
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-lg-6" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "phone" } }, [
                      _vm._v("Téléphone fixe :")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.lazy",
                          value: _vm.$v.inscription.phoneNumber.$model,
                          expression: "$v.inscription.phoneNumber.$model",
                          modifiers: { lazy: true }
                        }
                      ],
                      staticClass: "form-control",
                      class: {
                        "invalid-input":
                          _vm.$v.inscription.phoneNumber.$invalid &&
                          _vm.$v.inscription.phoneNumber.$dirty
                      },
                      attrs: {
                        placeholder: "Au moins un n° (fixe ou portable)",
                        type: "tel",
                        id: "phone"
                      },
                      domProps: {
                        value: _vm.$v.inscription.phoneNumber.$model
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(
                            _vm.$v.inscription.phoneNumber,
                            "$model",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    !_vm.$v.inscription.phoneNumber.telFormatIsValid
                      ? _c("div", { staticClass: "error-text" }, [
                          _vm._v(
                            "Merci de\n                                saisir un numéro de téléphone valide\n                            "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    (!_vm.$v.inscription.phoneNumber.atLeastOnePhoneNumber &&
                      _vm.$v.inscription.phoneNumber.$dirty) ||
                    _vm.errorField === "phoneNumbers"
                      ? _c("div", { staticClass: "error-text" }, [
                          _vm._v(
                            "\n                                Merci de\n                                saisir au moins un\n                                numéro de téléphone (fixe ou mobile)\n                            "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.errorField === "phone"
                      ? _c("div", { staticClass: "error-text" }, [
                          _vm._v(_vm._s(_vm.errorFieldMessage))
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-lg-6" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "mobilePhone" } }, [
                      _vm._v("Téléphone portable :")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.lazy",
                          value: _vm.$v.inscription.mobilePhoneNumber.$model,
                          expression: "$v.inscription.mobilePhoneNumber.$model",
                          modifiers: { lazy: true }
                        }
                      ],
                      staticClass: "form-control",
                      class: {
                        "invalid-input":
                          _vm.$v.inscription.mobilePhoneNumber.$invalid &&
                          _vm.$v.inscription.mobilePhoneNumber.$dirty
                      },
                      attrs: {
                        placeholder: "Au moins un n° (fixe ou portable)",
                        type: "tel",
                        id: "mobilePhone"
                      },
                      domProps: {
                        value: _vm.$v.inscription.mobilePhoneNumber.$model
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(
                            _vm.$v.inscription.mobilePhoneNumber,
                            "$model",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    !_vm.$v.inscription.mobilePhoneNumber.telFormatIsValid
                      ? _c("div", { staticClass: "error-text" }, [
                          _vm._v(
                            "Merci\n                                de saisir un numéro de téléphone valide\n                            "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    (!_vm.$v.inscription.mobilePhoneNumber
                      .atLeastOnePhoneNumber &&
                      _vm.$v.inscription.mobilePhoneNumber.$dirty) ||
                    _vm.errorField === "phoneNumbers"
                      ? _c("div", { staticClass: "error-text" }, [
                          _vm._v(
                            "\n                                Merci de\n                                saisir au moins un numéro de téléphone (fixe ou mobile)\n                            "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.errorField === "mobilePhone"
                      ? _c("div", { staticClass: "error-text" }, [
                          _vm._v(
                            _vm._s(_vm.errorFieldMessage) +
                              "\n                            "
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  { staticClass: "required-input", attrs: { for: "email" } },
                  [_vm._v("Adresse email :")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.lazy",
                      value: _vm.$v.inscription.email.$model,
                      expression: "$v.inscription.email.$model",
                      modifiers: { lazy: true }
                    }
                  ],
                  staticClass: "form-control",
                  class: {
                    "invalid-input":
                      _vm.$v.inscription.email.$invalid &&
                      _vm.$v.inscription.email.$dirty
                  },
                  attrs: {
                    placeholder: "Mon adresse Email en minuscule",
                    type: "email",
                    id: "email",
                    required: ""
                  },
                  domProps: { value: _vm.$v.inscription.email.$model },
                  on: {
                    change: function($event) {
                      return _vm.$set(
                        _vm.$v.inscription.email,
                        "$model",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                !_vm.$v.inscription.email.required &&
                _vm.$v.inscription.email.$dirty
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(
                        "\n                        Merci de saisir une adresse email\n                    "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$v.inscription.email.email
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(
                        "Merci de saisir une adresse email\n                        valide\n                    "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$v.inscription.email.maxLength
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v("250 caractères maximum")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.errorField === "email"
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(_vm._s(_vm.errorFieldMessage))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  { staticClass: "required-input", attrs: { for: "email2" } },
                  [_vm._v("Adresse email (validation) :")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.$v.emailConfirmation.$model,
                      expression: "$v.emailConfirmation.$model"
                    }
                  ],
                  staticClass: "form-control",
                  class: {
                    "invalid-input":
                      _vm.$v.emailConfirmation.$invalid &&
                      _vm.$v.emailConfirmation.$dirty
                  },
                  attrs: {
                    type: "email",
                    id: "email2",
                    required: "",
                    placeholder: "Merci de confirmer votre adresse mail"
                  },
                  domProps: { value: _vm.$v.emailConfirmation.$model },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.$v.emailConfirmation,
                        "$model",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                !_vm.$v.emailConfirmation.required &&
                _vm.$v.emailConfirmation.$dirty
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(
                        "\n                        Merci de confirmer l'adresse email\n                    "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$v.emailConfirmation.email
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(
                        "Merci de saisir une adresse email\n                        valide\n                    "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$v.emailConfirmation.sameAsEmail &&
                _vm.$v.emailConfirmation.$dirty
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(
                        "\n                        Les deux adresses emails doivent être identiques\n                    "
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "required-input",
                    attrs: { for: "identityPhoto" }
                  },
                  [_vm._v("Photo d'identité :")]
                ),
                _vm._v(" "),
                _c("div", [
                  _c("input", {
                    ref: "file_photoIdentity",
                    attrs: {
                      type: "file",
                      id: "identityPhoto",
                      accept: ".png, .jpg, .jpeg, .gif"
                    },
                    domProps: {
                      textContent: _vm._s(_vm.$t("entity.action.addblob"))
                    },
                    on: {
                      change: function($event) {
                        return _vm.validateFileOnChange(
                          $event,
                          _vm.inscription,
                          "photoIdentity",
                          false
                        )
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.$v.inscription.photoIdentity.$model,
                      expression: "$v.inscription.photoIdentity.$model"
                    }
                  ],
                  staticClass: "form-control",
                  class: {
                    "invalid-input":
                      _vm.$v.inscription.photoIdentity.$invalid &&
                      _vm.showErrors
                  },
                  attrs: {
                    type: "hidden",
                    name: "photoIdentity",
                    id: "inscription-photoIdentity",
                    required: ""
                  },
                  domProps: { value: _vm.$v.inscription.photoIdentity.$model },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.$v.inscription.photoIdentity,
                        "$model",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inscription.photoIdentityContentType,
                      expression: "inscription.photoIdentityContentType"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "hidden",
                    name: "photoIdentityContentType",
                    id: "inscription-photoIdentityContentType"
                  },
                  domProps: { value: _vm.inscription.photoIdentityContentType },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.inscription,
                        "photoIdentityContentType",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "list-unstyled form-text text-muted mb-0" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm._m(2),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(
                        "Formats acceptés : images (.png, .jpg, .jpeg, .gif)."
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(
                        "Taille maximum autorisée : " +
                          _vm._s(_vm.maxFileSize / 1000) +
                          " Mo."
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.errorPhotoIdentityRequired
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(
                        "Merci d'ajouter une photo d'identité\n                    "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.errorPhotoIdentityMinSize
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(
                        "\n                        La taille du fichier doit être supérieure à " +
                          _vm._s(_vm.minFileSize) +
                          " ko\n                    "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.errorPhotoIdentityMaxSize
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(
                        "\n                        La taille du fichier ne doit pas excéder " +
                          _vm._s(_vm.maxFileSize / 1000) +
                          " Mo\n                    "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.errorPhotoIdentityType
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(
                        "Le fichier doit être de type image (.png,\n                        .jpg, .jpeg, .gif)\n                    "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.errorField === "identityPhoto"
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(_vm._s(_vm.errorFieldMessage))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "required-input",
                    attrs: { for: "identityCard" }
                  },
                  [
                    _vm._v(
                      "Carte d'identité : Carte d'identité recto/verso\n                        ou passeport"
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", [
                  _c("input", {
                    ref: "file_cardIdentity",
                    attrs: {
                      type: "file",
                      id: "identityCard",
                      accept: ".pdf, .png, .jpg, .jpeg, .gif"
                    },
                    domProps: {
                      textContent: _vm._s(_vm.$t("entity.action.addblob"))
                    },
                    on: {
                      change: function($event) {
                        return _vm.validateFileOnChange(
                          $event,
                          _vm.inscription,
                          "cardIdentity",
                          false
                        )
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.$v.inscription.cardIdentity.$model,
                      expression: "$v.inscription.cardIdentity.$model"
                    }
                  ],
                  staticClass: "form-control",
                  class: {
                    "invalid-input":
                      _vm.$v.inscription.cardIdentity.$invalid && _vm.showErrors
                  },
                  attrs: {
                    type: "hidden",
                    name: "cardIdentity",
                    id: "inscription-cardIdentity",
                    required: ""
                  },
                  domProps: { value: _vm.$v.inscription.cardIdentity.$model },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.$v.inscription.cardIdentity,
                        "$model",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inscription.cardIdentityContentType,
                      expression: "inscription.cardIdentityContentType"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "hidden",
                    name: "cardIdentityContentType",
                    id: "inscription-cardIdentityContentType"
                  },
                  domProps: { value: _vm.inscription.cardIdentityContentType },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.inscription,
                        "cardIdentityContentType",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "list-unstyled form-text text-muted mb-0" },
                  [
                    _c("li", [
                      _vm._v(
                        "Formats acceptés : PDF (.pdf) et images (.png, .jpg, .jpeg, .gif)."
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(
                        "Taille maximum autorisée : " +
                          _vm._s(_vm.maxFileSize / 1000) +
                          " Mo."
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.errorCardIdentityRequired
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(
                        "Merci d'ajouter une carte d'identité\n                    "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.errorCardIdentityMinSize
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(
                        "\n                        La taille du fichier doit être supérieure à " +
                          _vm._s(_vm.minFileSize) +
                          " ko\n                    "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.errorCardIdentityMaxSize
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(
                        "\n                        La taille du fichier ne doit pas excéder " +
                          _vm._s(_vm.maxFileSize / 1000) +
                          " Mo\n                    "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.errorCardIdentityType
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(
                        "Le fichier doit être de type image (.png,\n                        .jpg, .jpeg, .gif) ou PDF\n                    "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.errorField === "identityCard"
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(_vm._s(_vm.errorFieldMessage))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm._m(3),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "legend",
                    {
                      staticClass: "col-form-label required-input col-sm-2 pt-0"
                    },
                    [_vm._v("Type d'examen :")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-10" }, [
                    _c(
                      "div",
                      { staticClass: "form-check form-check-inline mr-5" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inscription.examSessionType,
                              expression: "inscription.examSessionType"
                            }
                          ],
                          staticClass: "form-check-input",
                          attrs: {
                            type: "radio",
                            name: "maritime",
                            required: "",
                            id: "maritime",
                            value: "MARITIME"
                          },
                          domProps: {
                            checked: _vm._q(
                              _vm.inscription.examSessionType,
                              "MARITIME"
                            )
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(
                                _vm.inscription,
                                "examSessionType",
                                "MARITIME"
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label",
                            attrs: { for: "maritime" }
                          },
                          [_vm._v("CRR Maritime")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-check form-check-inline mr-5" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inscription.examSessionType,
                              expression: "inscription.examSessionType"
                            }
                          ],
                          staticClass: "form-check-input",
                          attrs: {
                            type: "radio",
                            name: "fluvial",
                            required: "",
                            id: "fluvial",
                            value: "FLUVIAL"
                          },
                          domProps: {
                            checked: _vm._q(
                              _vm.inscription.examSessionType,
                              "FLUVIAL"
                            )
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(
                                _vm.inscription,
                                "examSessionType",
                                "FLUVIAL"
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label",
                            attrs: { for: "fluvial" }
                          },
                          [_vm._v("CRR Fluvial")]
                        )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                !_vm.$v.inscription.examSessionType.required &&
                _vm.$v.inscription.examSessionType.$dirty
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(
                        "\n                        Il faut préciser si vous souhaitez passer le CRR maritime ou fluvial\n                    "
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "examSessionCity" } }, [
                  _vm._v("Lieu d'examen :")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inscription.examSessionCity,
                      expression: "inscription.examSessionCity"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { id: "examSessionCity", type: "text" },
                  domProps: { value: _vm.inscription.examSessionCity },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.inscription,
                        "examSessionCity",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "examSessionDate" } }, [
                  _vm._v("Date d'examen :")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inscription.examSessionDate,
                      expression: "inscription.examSessionDate"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    placeholder: "JJ/MM/AAAA",
                    id: "examSessionDate",
                    type: "text"
                  },
                  domProps: { value: _vm.inscription.examSessionDate },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.inscription,
                        "examSessionDate",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "font-italic" }, [
                  _vm._v(
                    "Attention une session ouverte visualisée sur notre site peut entretemps\n                        ne plus être disponible."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group form-check" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inscription.candidateIsCardHolder,
                      expression: "inscription.candidateIsCardHolder"
                    }
                  ],
                  staticClass: "form-check-input",
                  attrs: { type: "checkbox", id: "candidateIsCardHolder" },
                  domProps: {
                    checked: Array.isArray(
                      _vm.inscription.candidateIsCardHolder
                    )
                      ? _vm._i(_vm.inscription.candidateIsCardHolder, null) > -1
                      : _vm.inscription.candidateIsCardHolder
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.inscription.candidateIsCardHolder,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.inscription,
                              "candidateIsCardHolder",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.inscription,
                              "candidateIsCardHolder",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.inscription, "candidateIsCardHolder", $$c)
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "form-check-label",
                    attrs: { for: "candidateIsCardHolder" }
                  },
                  [
                    _vm._v(
                      "Le candidat à l'inscription est le\n                        titulaire de la carte de paiement\n                    "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              !_vm.inscription.candidateIsCardHolder
                ? _c("fieldset", [
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        {
                          staticClass: "required-input",
                          attrs: { for: "nameCardHolder" }
                        },
                        [
                          _vm._v(
                            "Nom et prénom ou raison sociale du\n                            titulaire de la carte :"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.lazy",
                            value: _vm.$v.inscription.nameCardHolder.$model,
                            expression: "$v.inscription.nameCardHolder.$model",
                            modifiers: { lazy: true }
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "invalid-input":
                            _vm.$v.inscription.nameCardHolder.$invalid &&
                            _vm.$v.inscription.nameCardHolder.$dirty
                        },
                        attrs: {
                          type: "text",
                          id: "nameCardHolder",
                          required: ""
                        },
                        domProps: {
                          value: _vm.$v.inscription.nameCardHolder.$model
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(
                              _vm.$v.inscription.nameCardHolder,
                              "$model",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      !_vm.$v.inscription.nameCardHolder.required &&
                      _vm.$v.inscription.nameCardHolder.$dirty
                        ? _c("div", { staticClass: "error-text" }, [
                            _vm._v(
                              "\n                            Merci de saisir le nom et prénom ou la\n                            raison sociale\n                        "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.inscription.nameCardHolder.maxLength
                        ? _c("div", { staticClass: "error-text" }, [
                            _vm._v(
                              "250 caractères\n                            maximum\n                        "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errorField === "nameCardHolder"
                        ? _c("div", { staticClass: "error-text" }, [
                            _vm._v(_vm._s(_vm.errorFieldMessage))
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        {
                          staticClass: "required-input",
                          attrs: { for: "address1CardHolder" }
                        },
                        [
                          _vm._v(
                            "Adresse du titulaire de la carte\n                            :"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.lazy",
                            value: _vm.$v.inscription.address1CardHolder.$model,
                            expression:
                              "$v.inscription.address1CardHolder.$model",
                            modifiers: { lazy: true }
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "invalid-input":
                            _vm.$v.inscription.address1CardHolder.$invalid &&
                            _vm.$v.inscription.address1CardHolder.$dirty
                        },
                        attrs: {
                          id: "address1CardHolder",
                          type: "text",
                          required: ""
                        },
                        domProps: {
                          value: _vm.$v.inscription.address1CardHolder.$model
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(
                              _vm.$v.inscription.address1CardHolder,
                              "$model",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      !_vm.$v.inscription.address1CardHolder.required &&
                      _vm.$v.inscription.address1CardHolder.$dirty
                        ? _c("div", { staticClass: "error-text" }, [
                            _vm._v(
                              "\n                            Merci de saisir une adresse\n                        "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.inscription.address1CardHolder.maxLength
                        ? _c("div", { staticClass: "error-text" }, [
                            _vm._v(
                              "250 caractères\n                            maximum\n                        "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errorField === "address1CardHolder"
                        ? _c("div", { staticClass: "error-text" }, [
                            _vm._v(
                              _vm._s(_vm.errorFieldMessage) +
                                "\n                        "
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "address2CardHolder" } }, [
                        _vm._v("Adresse 2 du titulaire de la carte :")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.lazy",
                            value: _vm.$v.inscription.address2CardHolder.$model,
                            expression:
                              "$v.inscription.address2CardHolder.$model",
                            modifiers: { lazy: true }
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "invalid-input":
                            _vm.$v.inscription.address2CardHolder.$invalid &&
                            _vm.$v.inscription.address2CardHolder.$dirty
                        },
                        attrs: {
                          id: "address2CardHolder",
                          type: "text",
                          required: ""
                        },
                        domProps: {
                          value: _vm.$v.inscription.address2CardHolder.$model
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(
                              _vm.$v.inscription.address2CardHolder,
                              "$model",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.errorField === "address2CardHolder"
                        ? _c("div", { staticClass: "error-text" }, [
                            _vm._v(
                              _vm._s(_vm.errorFieldMessage) +
                                "\n                        "
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 col-lg-6" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            { attrs: { for: "postalCodeCardHolder" } },
                            [_vm._v("Code postal du titulaire de la carte :")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.lazy",
                                value:
                                  _vm.$v.inscription.postalCodeCardHolder
                                    .$model,
                                expression:
                                  "$v.inscription.postalCodeCardHolder.$model",
                                modifiers: { lazy: true }
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "invalid-input":
                                _vm.$v.inscription.postalCodeCardHolder
                                  .$invalid &&
                                _vm.$v.inscription.postalCodeCardHolder.$dirty
                            },
                            attrs: {
                              placeholder: "Exemple : 88100",
                              type: "text",
                              id: "postalCodeCardHolder",
                              required: ""
                            },
                            domProps: {
                              value:
                                _vm.$v.inscription.postalCodeCardHolder.$model
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.$v.inscription.postalCodeCardHolder,
                                  "$model",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.errorField === "postalCodeCardHolder"
                            ? _c("div", { staticClass: "error-text" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.errorFieldMessage) +
                                    "\n                                "
                                )
                              ])
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 col-lg-6" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "required-input",
                              attrs: { for: "cityCardHolder" }
                            },
                            [
                              _vm._v(
                                "Commune du titulaire de la carte\n                                    :"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.lazy",
                                value: _vm.$v.inscription.cityCardHolder.$model,
                                expression:
                                  "$v.inscription.cityCardHolder.$model",
                                modifiers: { lazy: true }
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "invalid-input":
                                _vm.$v.inscription.cityCardHolder.$invalid &&
                                _vm.$v.inscription.cityCardHolder.$dirty
                            },
                            attrs: {
                              type: "text",
                              id: "cityCardHolder",
                              required: ""
                            },
                            domProps: {
                              value: _vm.$v.inscription.cityCardHolder.$model
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.$v.inscription.cityCardHolder,
                                  "$model",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          !_vm.$v.inscription.cityCardHolder.required &&
                          _vm.$v.inscription.cityCardHolder.$dirty
                            ? _c("div", { staticClass: "error-text" }, [
                                _vm._v(
                                  "\n                                    Merci de saisir une ville\n                                "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.$v.inscription.cityCardHolder.maxLength
                            ? _c("div", { staticClass: "error-text" }, [
                                _vm._v(
                                  "50\n                                    caractères maximum\n                                "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.errorField === "cityCardHolder"
                            ? _c("div", { staticClass: "error-text" }, [
                                _vm._v(
                                  _vm._s(_vm.errorFieldMessage) +
                                    "\n                                "
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        {
                          staticClass: "required-input",
                          attrs: { for: "countryCardHolder" }
                        },
                        [
                          _vm._v(
                            "Pays du titulaire de la carte\n                            :"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.lazy",
                              value:
                                _vm.$v.inscription.countryCardHolder.$model,
                              expression:
                                "$v.inscription.countryCardHolder.$model",
                              modifiers: { lazy: true }
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "invalid-input":
                              _vm.$v.inscription.countryCardHolder.$invalid &&
                              _vm.$v.inscription.countryCardHolder.$dirty
                          },
                          attrs: { id: "countryCardHolder", required: "" },
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.$v.inscription.countryCardHolder,
                                  "$model",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              _vm.onChangeCountryInput
                            ]
                          }
                        },
                        _vm._l(_vm.countryEnum, function(country) {
                          return _c(
                            "option",
                            {
                              attrs: { label: country },
                              domProps: { value: country }
                            },
                            [
                              _vm._v(
                                _vm._s(country) +
                                  "\n                            "
                              )
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm.errorField === "countryCardHolder"
                        ? _c("div", { staticClass: "error-text" }, [
                            _vm._v(
                              _vm._s(_vm.errorFieldMessage) +
                                "\n                        "
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 col-lg-6" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "phoneCardHolder" } }, [
                            _vm._v("Tél. fixe du titulaire de la carte :")
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.lazy",
                                value:
                                  _vm.$v.inscription.phoneNumberCardHolder
                                    .$model,
                                expression:
                                  "$v.inscription.phoneNumberCardHolder.$model",
                                modifiers: { lazy: true }
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "invalid-input":
                                _vm.$v.inscription.phoneNumberCardHolder
                                  .$invalid &&
                                _vm.$v.inscription.phoneNumberCardHolder.$dirty
                            },
                            attrs: {
                              placeholder: "Au moins un n° (fixe ou portable)",
                              type: "tel",
                              id: "phoneCardHolder"
                            },
                            domProps: {
                              value:
                                _vm.$v.inscription.phoneNumberCardHolder.$model
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.$v.inscription.phoneNumberCardHolder,
                                  "$model",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          (!_vm.$v.inscription.phoneNumberCardHolder.required &&
                            _vm.$v.inscription.phoneNumberCardHolder.$dirty) ||
                          _vm.errorField === "phoneNumbers"
                            ? _c("div", { staticClass: "error-text" }, [
                                _vm._v(
                                  "\n                                    Merci de saisir au moins un numéro de téléphone (fixe ou mobile)\n                                "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.errorField === "phoneCardHolder"
                            ? _c("div", { staticClass: "error-text" }, [
                                _vm._v(
                                  _vm._s(_vm.errorFieldMessage) +
                                    "\n                                "
                                )
                              ])
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 col-lg-6" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            { attrs: { for: "mobilePhoneCardHolder" } },
                            [_vm._v("Tél. portable du titulaire de la carte :")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.lazy",
                                value:
                                  _vm.$v.inscription.mobilePhoneNumberCardHolder
                                    .$model,
                                expression:
                                  "$v.inscription.mobilePhoneNumberCardHolder.$model",
                                modifiers: { lazy: true }
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "invalid-input":
                                _vm.$v.inscription.mobilePhoneNumberCardHolder
                                  .$invalid &&
                                _vm.$v.inscription.mobilePhoneNumberCardHolder
                                  .$dirty
                            },
                            attrs: {
                              placeholder: "Au moins un n° (fixe ou portable)",
                              type: "tel",
                              id: "mobilePhoneCardHolder"
                            },
                            domProps: {
                              value:
                                _vm.$v.inscription.mobilePhoneNumberCardHolder
                                  .$model
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.$v.inscription
                                    .mobilePhoneNumberCardHolder,
                                  "$model",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          (!_vm.$v.inscription.mobilePhoneNumberCardHolder
                            .required &&
                            _vm.$v.inscription.mobilePhoneNumberCardHolder
                              .$dirty) ||
                          _vm.errorField === "phoneNumbers"
                            ? _c("div", { staticClass: "error-text" }, [
                                _vm._v(
                                  "\n                                    Merci de saisir au moins un numéro de téléphone (fixe ou mobile)\n                                "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.errorField === "mobilePhoneCardHolder"
                            ? _c("div", { staticClass: "error-text" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.errorFieldMessage) +
                                    "\n                                "
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        {
                          staticClass: "required-input",
                          attrs: { for: "emailCardHolder" }
                        },
                        [
                          _vm._v(
                            "Adresse email du titulaire de la carte\n                            :"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.lazy",
                            value: _vm.$v.inscription.emailCardHolder.$model,
                            expression: "$v.inscription.emailCardHolder.$model",
                            modifiers: { lazy: true }
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "invalid-input":
                            _vm.$v.inscription.emailCardHolder.$invalid &&
                            _vm.$v.inscription.emailCardHolder.$dirty
                        },
                        attrs: {
                          placeholder: "Adresse Email en minuscule",
                          type: "email",
                          id: "emailCardHolder",
                          required: ""
                        },
                        domProps: {
                          value: _vm.$v.inscription.emailCardHolder.$model
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(
                              _vm.$v.inscription.emailCardHolder,
                              "$model",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      !_vm.$v.inscription.emailCardHolder.required &&
                      _vm.$v.inscription.emailCardHolder.$dirty
                        ? _c("div", { staticClass: "error-text" }, [
                            _vm._v(
                              "\n                            Merci de saisir une adresse email\n                        "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.inscription.emailCardHolder.email
                        ? _c("div", { staticClass: "error-text" }, [
                            _vm._v(
                              "Merci de saisir une\n                            adresse email valide\n                        "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.inscription.emailCardHolder.maxLength
                        ? _c("div", { staticClass: "error-text" }, [
                            _vm._v(
                              "250 caractères\n                            maximum\n                        "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errorField === "emailCardHolder"
                        ? _c("div", { staticClass: "error-text" }, [
                            _vm._v(
                              _vm._s(_vm.errorFieldMessage) +
                                "\n                        "
                            )
                          ])
                        : _vm._e()
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group form-check" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.$v.checkboxCgv.$model,
                      expression: "$v.checkboxCgv.$model"
                    }
                  ],
                  staticClass: "form-check-input",
                  class: {
                    "invalid-input":
                      _vm.$v.checkboxCgv.$invalid && _vm.$v.checkboxCgv.$dirty
                  },
                  attrs: { type: "checkbox", id: "cgv", required: "" },
                  domProps: {
                    checked: Array.isArray(_vm.$v.checkboxCgv.$model)
                      ? _vm._i(_vm.$v.checkboxCgv.$model, null) > -1
                      : _vm.$v.checkboxCgv.$model
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.$v.checkboxCgv.$model,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.$v.checkboxCgv,
                              "$model",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.$v.checkboxCgv,
                              "$model",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.$v.checkboxCgv, "$model", $$c)
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "form-check-label required-input",
                    attrs: { for: "cgv" }
                  },
                  [
                    _vm._v("J'accepte les\n                        "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-modal",
                            rawName: "v-b-modal.cgv",
                            modifiers: { cgv: true }
                          }
                        ],
                        staticClass: "link-underline"
                      },
                      [_vm._v("Conditions Générales d'Utilisation (CGU)")]
                    )
                  ]
                ),
                _vm._v(" "),
                !_vm.$v.checkboxCgv.sameAs && _vm.$v.checkboxCgv.$dirty
                  ? _c("div", { staticClass: "error-text" }, [
                      _vm._v(
                        "Merci d'accepter\n                        les CGU\n                    "
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "b-modal",
                {
                  attrs: {
                    id: "cgv",
                    title: "Conditions Générales d'Utilisation (CGU)",
                    scrollable: "",
                    "ok-title": "OK",
                    "cancel-title": "Fermer"
                  }
                },
                [_c("div", { staticClass: "my-2" }, [_c("cgv-page")], 1)]
              ),
              _vm._v(" "),
              _c("captchetat-widget", {
                on: { validated: _vm.onCaptchaValidated }
              }),
              _vm._v(" "),
              !_vm.captchaValidated && _vm.showErrors
                ? _c("div", { staticClass: "error-text mt-2" }, [
                    _vm._v(
                      "\n                    Veuillez valider le captcha avant de procéder au paiement\n                "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-lg mt-3",
                  attrs: {
                    type: "submit",
                    disabled: _vm.isSaving || !_vm.captchaValidated
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.submit($event)
                    }
                  }
                },
                [_vm._v("Procéder au paiement\n                ")]
              ),
              _vm._v(" "),
              _vm.isSaving
                ? _c("div", { staticClass: "ml-4 d-inline-block" }, [_vm._m(4)])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.globalErrorMessage !== "",
                      expression: "globalErrorMessage !== ''"
                    }
                  ],
                  staticClass: "alert alert-danger mt-3",
                  attrs: { role: "alert" }
                },
                [_vm._v(_vm._s(_vm.globalErrorMessage) + "\n                ")]
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "payedRegistrationExists",
          attrs: { id: "payedRegistrationExists" }
        },
        [
          _c("span", { attrs: { slot: "modal-title" }, slot: "modal-title" }, [
            _vm._v("Premier règlement déjà effectué")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c("p", [
              _vm._v(
                "Attention, vous avez déjà effectué un premier règlement de " +
                  _vm._s(_vm.registrationFee) +
                  " pour\n                l’inscription et si vous n’avez pas encore passé l’examen, il est inutile de vous réinscrire au\n                risque de payer une seconde fois."
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "modal-footer" }, slot: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.closeDialogPayedRegistrationExists()
                  }
                }
              },
              [_vm._v("Retour au formulaire\n            ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button", disabled: _vm.isSaving },
                on: {
                  click: function($event) {
                    _vm.inscription.dualRegistration = true
                    _vm.save()
                  }
                }
              },
              [_vm._v("Procéder au paiement\n            ")]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "txt-small mb-4" }, [
      _vm._v("Les champs suivis d'un "),
      _c("span", { staticClass: "txt-pink font-weight-bold" }, [_vm._v("*")]),
      _vm._v(" sont\n                obligatoires")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "txt-red" }, [
      _vm._v(
        "Critères de la photo couleur (3,5 x 4,5 cm : ratio 7/9), cliquez "
      ),
      _c(
        "a",
        {
          staticClass: "link-underline",
          attrs: {
            href: "https://www.service-public.fr/particuliers/vosdroits/F10619",
            target: "_blank"
          }
        },
        [_vm._v("ici")]
      ),
      _vm._v(".\n                        ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "txt-red" }, [
      _c("strong", [
        _vm._v(
          "Si la photo ne respecte pas ces critères, vous ne pourrez\n                            recevoir votre CRR."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [
        _vm._v(
          "J'indique à l'ANFR la session d'examen souhaitée (visualisée depuis le calendrier CRR du\n                    site) :"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loader-dots" }, [
      _c("div"),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }